import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';

import Paper, { PaperProps } from '../Paper';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: '0.7rem',
    overflow: 'auto',
    position: 'relative',
    zIndex: theme.zIndex.appBar - 1,
  },
  padLeft: {
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
    },
  },
  padBottom: {
    paddingBottom: '0.7rem',
  },
}));

interface Props {
  padLeft?: boolean;
  padBottom?: boolean;
}

const BreadcrumbsWrapper: React.FC<PaperProps & Props> = ({
  children,
  padLeft = true,
  padBottom = true,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Paper
      className={cx(
        classes.wrapper,
        padLeft && classes.padLeft,
        padBottom && classes.padBottom,
      )}
      elevation={3}
      square
      {...rest}
    >
      {children}
    </Paper>
  );
};

export { BreadcrumbsWrapper };
